import React from 'react';

function Contact() {
  return (
    <section className="bg-blue-50 py-12 px-4 md:px-0">
      <h2 className="text-2xl md:text-3xl font-bold text-blue-900 text-center mb-8">Nous contacter</h2>
      <div className="max-w-xl mx-auto bg-white rounded-xl shadow p-8">
        <form className="flex flex-col gap-4 mb-4">
          <input type="text" placeholder="Votre nom" className="border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-300" />
          <input type="email" placeholder="Votre email" className="border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-300" />
          <textarea placeholder="Votre message" className="border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-300" rows={4}></textarea>
          <button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-700 transition">Envoyer</button>
        </form>
        <p className="text-blue-700 text-center underline">contact@kora.app</p>
        <p className="text-blue-700 text-center">LinkedIn : <button type="button" className="underline">Lien LinkedIn</button></p>
      </div>
    </section>
  );
}

export default Contact; 